'use strict';

var React = require('react'),
    ReactBootstrap = require('react-bootstrap'),
    Navbar = ReactBootstrap.Navbar,
    Nav = ReactBootstrap.Nav,
    NavItem = ReactBootstrap.NavItem;

var ExternalNavbar = React.createClass({
	displayName: 'ExternalNavbar',

	propTypes: {
		loggedIn: React.PropTypes.bool.isRequired
	},

	render: function render() {
		var loggedIn = this.props.loggedIn;

		return React.createElement(
			Navbar,
			{ fixedTop: true },
			React.createElement(
				Navbar.Header,
				null,
				React.createElement(
					Navbar.Brand,
					null,
					React.createElement(
						'a',
						{ href: '/' },
						React.createElement('img', { src: '/logoWithName.png' })
					)
				),
				React.createElement(Navbar.Toggle, null)
			),
			React.createElement(
				Navbar.Collapse,
				null,
				React.createElement(
					Nav,
					{ pullRight: true },
					React.createElement(
						NavItem,
						{ href: '/gallery' },
						'Gallery'
					),
					React.createElement(
						NavItem,
						{ href: '/building-a-website-screenshot-generator' },
						'Technology'
					),
					React.createElement(
						NavItem,
						{ href: '/#pricing' },
						'Pricing'
					),
					React.createElement(
						NavItem,
						{ href: '/#contact' },
						'Contact'
					),
					React.createElement(
						NavItem,
						{ href: '/docs' },
						'Docs'
					),
					loggedIn ? null : React.createElement(
						NavItem,
						{ href: '/login' },
						'Login'
					),
					React.createElement(
						'li',
						null,
						React.createElement(
							'p',
							{ className: 'navbar-btn' },
							loggedIn ? React.createElement(
								'a',
								{ href: '/admin', className: 'btn btn-primary' },
								'Dashboard'
							) : React.createElement(
								'a',
								{ href: '/signup', className: 'btn btn-primary' },
								'Signup'
							)
						)
					)
				)
			)
		);
	}
});

module.exports = ExternalNavbar;


//////////////////
// WEBPACK FOOTER
// ./client/components/ExternalNavbar.js
// module id = 424
// module chunks = 0